export type BatteryRequestBody = {
  /**
   * kWh, maximum power consumption of the on-board charger.
   */
  chargingAC: number | null;
  /**
   * time in minutes required to charge the battery from 0 to 80% capacity when using a home AC charger
   */
  chargingTimeAC: number | null;
  /**
   * kWh, maximum power consumption on the fast DC charging stations
   */
  chargingDC: number | null;
  /**
   * time in minutes required to charge the battery from 0 to 80% capacity using the maximum DC power from the external fast charger
   */
  chargingTimeDC: number | null;
  /**
   * one of battery type
   */
  batteryType: string | null;
  /**
   * Battery capacity Wh
   */
  batteryCapacityWh: number | null;
  /**
   * Battery capacity Ah
   */
  batteryCapacityAh: number | null;
  /**
   * Battery Voltage V
   */
  batteryVoltage: number | null;
  batteryCount: number | null;
  /**
   * connector type for connection to the vehicle's on-board charger
   */
  chargingConnectorType: string | null;
  /**
   * the maximum number of kilometers the vehicle will cover after charging the battery to 100%
   */
  electricRange: number | null;
  /**
   * Limited warranty for battery and drive unit
   */
  batteryMileageLimit: number | null;
  batteryWarrantyUntil: string | null;
  /**
   * one of battery ownership type
   */
  batteryOwnershipType: string | null;
  hasRangeExtender: boolean | null;
};
